// frontend/src/components/TrialBanner.jsx
// Renders a contextual trial status banner on the Dashboard.
// Hidden for paid subscribers and platform owner.
// Yellow at 5+ days remaining, orange at 1–4 days, red at 0 days (should not show — wall takes over).
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PLATFORM_OWNER_ORG_ID = process.env.REACT_APP_PLATFORM_OWNER_ORG_ID;

export default function TrialBanner({ user }) {
  const navigate      = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (!user) return null;
  if (user.org_id === PLATFORM_OWNER_ORG_ID) return null;
  if (!user.trial_ends_at) return null;
  if (user.subscription_tier && user.subscription_tier !== 'pilot') return null;
  if (dismissed) return null;

  const now       = new Date();
  const endsAt    = new Date(user.trial_ends_at);
  const diffMs    = endsAt - now;
  const daysLeft  = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  if (daysLeft <= 0) return null; // wall handles this

  const expiryDate = endsAt.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });

  let bg, border, color, icon;
  if (daysLeft <= 1) {
    bg = '#fff7ed'; border = '#fed7aa'; color = '#c2410c'; icon = '⚠️';
  } else if (daysLeft <= 4) {
    bg = '#fffbeb'; border = '#fde68a'; color = '#92400e'; icon = '⏳';
  } else {
    bg = '#f0fdf4'; border = '#bbf7d0'; color = '#166534'; icon = '🟢';
  }

  const urgency = daysLeft === 1
    ? 'Your trial ends tomorrow'
    : `Your trial ends in ${daysLeft} days`;

  return (
    <div style={{
      background: bg,
      border: `1px solid ${border}`,
      borderRadius: 8,
      padding: '12px 16px',
      margin: '0 0 20px 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      flexWrap: 'wrap',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: 16, flexShrink: 0 }}>{icon}</span>
        <div style={{ fontSize: 13, color, lineHeight: 1.5 }}>
          <strong>{urgency}</strong> ({expiryDate}).{' '}
          Upgrade to keep uninterrupted access to your governance evidence.
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          onClick={() => navigate('/upgrade')}
          style={{
            background: '#132e50', color: '#fff',
            border: 'none', borderRadius: 5,
            fontSize: 12, fontWeight: 700,
            padding: '6px 14px', cursor: 'pointer',
          }}
        >
          Upgrade now
        </button>
        <button
          onClick={() => setDismissed(true)}
          style={{
            background: 'none', border: `1px solid ${border}`,
            borderRadius: 5, fontSize: 11,
            color, padding: '6px 10px', cursor: 'pointer',
          }}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
